import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import { UpdateServiceAsync } from "services/Services";
import i18next from "i18next";

export default function UpdateService() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(UpdateServiceAsync, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            message:
              i18next.language === "ar"
                ? "تم تعديل الخدمة بنجاح"
                : "Service has been updated successfullys",
          });
          queryClient.invalidateQueries("services-by-category");
          queryClient.invalidateQueries("services-by-level");
        }
      },
    }),
  };
}
